import {useCallback} from 'react';
import {useMutation} from '@apollo/client';
import {useAppDispatch} from '@/Pages/Common/hooks/useAppDispatch';
import {addedNewYear} from '../store/slice';
import createPartnerCostEntryYearMutation from '../graphql/createPartnerCostEntryYearMutation';
import {PartnerCostEntryYear} from '../store/types';

interface UseAddPartnerCostEntryYearResult {
  addPartnerCostEntryYear: (
    partnerId: string,
    onSuccess: (year: number) => void
  ) => Promise<void>;
}

export const useAddPartnerCostEntryYear =
  (): UseAddPartnerCostEntryYearResult => {
    const dispatch = useAppDispatch();

    const [createMutation] = useMutation<{
      createBusPartnerCostEntryYear: PartnerCostEntryYear;
    }>(createPartnerCostEntryYearMutation, {
      errorPolicy: 'all'
    });

    const addPartnerCostEntryYear = useCallback(
      async (partnerId: string, onSuccess: (year: number) => void) => {
        try {
          const {data, errors} = await createMutation({
            variables: {partnerId}
          });

          if (errors && errors.length > 0) {
            const errorMessage =
              errors[0]?.extensions?.errorMessage ?? errors[0].message;
            console.error('Add partner cost entry year error:', errorMessage);
            return;
          }

          if (data?.createBusPartnerCostEntryYear) {
            const newEntryYear = {
              ...data.createBusPartnerCostEntryYear,
              busPartnerId: partnerId
            };
            dispatch(addedNewYear(newEntryYear));
            onSuccess(newEntryYear.year);
          }
        } catch (error) {
          const errorMessage = `Unexpected error while adding partner cost entry year: ${error}`;
          console.error(errorMessage);
        }
      },
      [dispatch, createMutation]
    );

    return {addPartnerCostEntryYear};
  };
